import React from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import TrustBar from "../components/landing/TrustBar";
import Problem from "../components/landing/Problem";
import Solution from "../components/landing/Solution";
import PaymentConsolidation from "../components/landing/PaymentConsolidation";
import TopazAI from "../components/landing/TopazAI";
import PlatformTour from "../components/landing/PlatformTour";
import Categories from "../components/landing/Categories";
import Personas from "../components/landing/Personas";
import Integrations from "../components/landing/Integrations";
import Outcomes from "../components/landing/Outcomes";
import Scale from "../components/landing/Scale";
import HowItWorks from "../components/landing/HowItWorks";
import FAQ from "../components/landing/FAQ";
import LeadForm from "../components/landing/LeadForm";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="omnisupply-landing-page" className="min-h-screen bg-white text-slate-900">
      <Header />
      <Hero />
      <TrustBar />
      <Problem />
      <Solution />
      <PaymentConsolidation />
      <TopazAI />
      <PlatformTour />
      <Categories />
      <Personas />
      <Integrations />
      <Outcomes />
      <Scale />
      <HowItWorks />
      <FAQ />
      <LeadForm />
      <Footer />
    </main>
  );
}
